import { defineStore } from 'pinia';
import { parseFormData } from './applicationStore';

export const useMessageStore = defineStore('messageStore', {
    state: () => ({
        successMessage: '',
        errorMessage: '',
        recognizeMessage: ''
    }),

    actions: {
        setSuccessMessage(message) {
            this.successMessage = message;
        },

        setRecognizeMessage(message) {
            this.recognizeMessage = message;
        },

        setErrorMessage(message) {
            this.errorMessage = message;
        },

        clearMessages() {
            this.successMessage = '';
            this.errorMessage = '';
            this.recognizeMessage = '';
        },

        saveToLocalStorage() {
            try {
                const parsedData = parseFormData(this.$state);
                localStorage.setItem('messageStore', JSON.stringify(parsedData));
            } catch (error) {
                console.error('Error saving to localStorage:', error);
            }
        },

        loadFromLocalStorage() {
            try {
                const savedState = localStorage.getItem('messageStore');
                if (savedState) {
                    this.$patch(parseFormData(JSON.parse(savedState)));
                }
            } catch (error) {
                console.error('Error loading from localStorage:', error);
            }
        }
    }
});
